import { AvailableEntityBackendKeys } from '~/helpers/formatters';

const PUSH_NOTIFICATIONS_ROUTE = '/push-notifications';
export const ENTITY_KEY: AvailableEntityBackendKeys = 'TimedMessage';

export const PUSH_NOTIFICATIONS_ROUTES = {
  root: PUSH_NOTIFICATIONS_ROUTE,
  edit: [`${PUSH_NOTIFICATIONS_ROUTE}/new`, `${PUSH_NOTIFICATIONS_ROUTE}/:id`]
};
